const DeleteID = () => {
    return (
        <>
        <>
            <div className="managementID-wrapper">
                <p>Delete an employee’s account to prevent login after they leave the company.</p>

                <div className="managementID-inner">
                    <label>
                        Delete Employee’s account
                        <input placeholder="Enter Employee's ID">
                        </input>
                        <p>It is a 4-digit numerical ID that has been created (no letters, e.g: 1234)</p>
                    </label>                    
                    <div className="flex-button">
                        <button>
                            Check
                        </button>
                    </div>
                </div>

            </div>
        </>
        </>
    )
}

export default DeleteID;